import React from "react";
import styled from "styled-components";
import { SCREEN_WIDTH_BREAKPOINT } from "constant/common_constants";
import GroupShort from "../GroupShort/GroupShort";

type GroupLiElData = {
  link: string;
  name: string;
  image: string;
  text: string;
};

type Props = {
  groupsData: GroupLiElData[];
};

const GroupList = ({ groupsData }: Props) => {
  return (
    <ArtistWrapper>
      {groupsData.map((group, index) => (
        <GroupShort
          key={`group_li_el_${index}`}
          image={group.image}
          name={group.name}
          link={group.link}
          text={group.text}
        />
      ))}
    </ArtistWrapper>
  );
};

export const ArtistWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 2rem;
  margin-top: 1rem;
  padding-bottom: 3rem;
  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    width: 50%;
    margin-top: 0;
  }
`;

export default GroupList;
